module.exports = __webpack_public_path__ + "img/service-img.0ff21ad9.png";